(() => {
  try {
    var e = navigator,
      t = e.userAgent,
      r = 0,
      a = (e, t, r) => e.setAttribute(t, r),
      o = (e, t) => e.removeAttribute(t),
      d = "tagName",
      n = "forEach",
      l = "indexOf";
    ((e.platform[l]("x86_64") > -1 && 0 > t[l]("CrOS")) ||
      t[l]("power") > -1 ||
      t[l]("rix") > -1) &&
      new MutationObserver((e) => {
        e[n](({ addedNodes: e }) => {
          e[n]((e) => {
            1 === e.nodeType &&
              ("IFRAME" === e[d] &&
                (a(e, "loading", "lazy"), a(e, "data-src", e.src), o(e, "src")),
              "IMG" === e[d] && r++ > 20 && a(e, "loading", "lazy"),
              "SCRIPT" === e[d] &&
                (a(e, "data-src", e.src),
                o(e, "src"),
                (e.type = "text/lazyload")));
          });
        });
      }).observe(document.documentElement, { childList: !0, subtree: !0 });
    var c = (e) => document.querySelector(e),
      s = () => Date.now(),
      i = s(),
      u = () => {
        if (!(s() - i > 500)) {
          if (!c("body>meta")) return setTimeout(u, 5);
          var e = c("head");
          document
            .querySelectorAll("meta,link:not([rel='stylesheet']),title")
            [n]((t) => e.append(t));
        }
      };
    u();
  } catch (m) {}
})();
